export default __webpack_public_path__ + "static/media/casino-chips-ico-yellow.a1a2e0de.svg";